import { Box, Container, Grid, Typography } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { coachexp } from "../../assets";
const gold = "#c6a15b";

const SlickSlider = Slider as unknown as React.FC<any>;


const images = [
  "https://dprstorage.b-cdn.net/RW/leadgen/rw%20img%2052546%20(1).png",
  coachexp,
  // "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c",
];


const NextArrow = ({ onClick }: any) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      right: {xs:-15,md:-20,} ,// ❗ DON'T use negative
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 9999, // ✅ VERY HIGH
      width: 45,
      height: 45,
      borderRadius: "50%",
      background: "#0f63a5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#fff",
      fontSize: 22,
      boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    }}
  >
    ›
  </Box>
);

const PrevArrow = ({ onClick }: any) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      left:{xs:-15,md:-20,} ,
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 9999,
      width: 45,
      height: 45,
      borderRadius: "50%",
      background: "#0f63a5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#fff",
      fontSize: 22,
      boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    }}
  >
    ‹
  </Box>
);

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  pauseOnHover: false,
  nextArrow: <NextArrow />,   // ✅ ADD
  prevArrow: <PrevArrow />,   // ✅ ADD
};



const MentorSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: 4,
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          left: "50%",
          transform: "translateX(-50%)",
          width: "70%",
          height: "2px",
          background:
            "linear-gradient(90deg, transparent, rgba(18, 122, 170, 0.5), transparent)",
        }}
      />

      <Container maxWidth="lg">


        <Grid container spacing={8} alignItems="center">


          {/* LEFT CARD */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: 450,
                borderRadius: "16px",
                overflow: "visible",
                position: "relative",

                "& .slick-dots": {
  bottom: 10, // ✅ bring inside
},

"& .slick-dots li button:before": {
  fontSize: "12px",
  color: "#0f63a5",
  opacity: 0.4,
},

"& .slick-dots li.slick-active button:before": {
  color: "#0f63a5",
  opacity: 1,
},

                /* 🔵 ARROWS COLOR */
                "& .slick-prev:before, & .slick-next:before": {
                  color: "#0f63a5",
                  fontSize: "30px",
                },

                /* 🔥 POSITION FIX */
                "& .slick-prev": {
                  left: 10,
                  zIndex: 2,
                },

                "& .slick-next": {
                  right: 10,
                  zIndex: 2,
                },
              }}
            >

              <SlickSlider {...sliderSettings}>
                {images.map((img, i) => (
                  <Box key={i} sx={{ position: "relative" }}>

                    {/* IMAGE */}
                    <Box
                      component="img"
                      src={img}
                      sx={{
                        width: "100%",
                        height: 450,
                        objectFit: "cover",
                      }}
                    />

                    {/* OVERLAY */}
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.2))",
                      }}
                    />

                    {/* NAME */}
                    {/* <Typography
                      sx={{
                        position: "absolute",
                        bottom: 20,
                        left: 20,
                        color: "#c6a15b",
                        fontFamily: "Playfair Display",
                        fontSize: 16,
                        fontWeight: 500,
                      }}
                    >
                      Rajiv Williams
                    </Typography> */}

                  </Box>
                ))}
              </SlickSlider>

            </Box>
          </Grid>

          {/* RIGHT CONTENT */}
          <Grid item xs={12} md={6}>

            {/* GOLD LINE */}
            {/* <Box
              sx={{
                width: 50,
                height: 3,
                backgroundColor: gold,
                mb: 3,
              }}
            /> */}

            {/* HEADING */}
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Playfair Display",
                fontSize:{xs:"18px",md:"auto"},
                fontWeight: 600,
                lineHeight: 1.2,
                color: "#000",
                mb: 1,
                textAlign: 'start'
              }}
            >
              RW Realty

            </Typography>

            <Typography
              variant="h3"
              sx={{

                // fontSize: { xs: 36, md: 42 },
                fontWeight: 600,
                lineHeight: 1.2,
                color: "#0f63a5",
                mb: 1,
                textAlign: 'start'
              }}
            >
              Luxury Real Estate Sales & Strategic Advisory


            </Typography>


            {/* PARAGRAPH */}
            <Typography
              variant="body2"
              sx={{

                color: "#000",
                fontSize: 16,
                lineHeight: 1.7,
                mb: 1,
                maxWidth: 520,
                textAlign: 'start'
              }}
            >
              Behind every high-performing project is a sales system that works.

            </Typography>
            <Typography
              variant="body2"
              sx={{

                color: "#000",
                fontSize: 16,
                lineHeight: 1.7,
                mb: 4,
                maxWidth: 520,
                textAlign: 'start'
              }}
            >
              At RW Realty, we partner with developers to build, manage, and optimize sales ecosystems that don’t just generate activity but drive real closures, stronger deals, and predictable revenue
            </Typography>

            {/* FEATURE LIST */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 4, textAlign: 'start' }}>

              {/* ITEM 1 */}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    width: 3,
                    backgroundColor: '#0f63a5',
                    borderRadius: "2px",
                  }}
                />

                <Box>
                  <Typography
                    variant="h6"
                    sx={{

                      fontSize: {xs:20,md:26},
                      color: '#0f63a5',
                      fontWeight: 600,
                    }}
                  >
                    Sales Ecosystem Architecture
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{

                      color: "#000",
                      fontSize: 15,
                      mt: 1,
                    }}
                  >
                    Designing structured sales systems that drive consistent closures
                  </Typography>
                </Box>
              </Box>

              {/* ITEM 2 */}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    width: 3,
                    backgroundColor: '#0f63a5',
                    borderRadius: "2px",
                  }}
                />

                <Box>
                  <Typography
                    variant="h6"
                    sx={{

                      fontSize: {xs:20,md:26},
                      color: '#0f63a5',
                      fontWeight: 600,
                    }}
                  >
                    Inventory Movement & Revenue Acceleration
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{

                      color: "#000",
                      fontSize: 15,
                      mt: 1,
                    }}
                  >
                    Improving conversion rates and reducing holding cycles
                  </Typography>
                </Box>
              </Box>

              {/* ITEM 3 */}
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box
                  sx={{
                    width: 3,
                    backgroundColor: '#0f63a5',
                    borderRadius: "2px",
                  }}
                />

                <Box>
                  <Typography
                    variant="h6"
                    sx={{

                      fontSize: {xs:20,md:26},
                      color: '#0f63a5',
                      fontWeight: 600,
                    }}
                  >
                    Sales Execution & Deal Control
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{

                      color: "#000",
                      fontSize: 15,
                      mt: 1,
                    }}
                  >
                    Managing real conversations, site visits, and closures
                  </Typography>
                </Box>
              </Box>

            </Box>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

export default MentorSection